<template>
    <CModal :title="task.name" color="primary" :show.sync="value" :disabled="!inputEnabled">
        <!-- Tools -->
        <CRow>
            <CCol sm="12" v-if="taskDetails">
                <div v-for="tool in taskDetails.tools.filter(tool => tool.used)" :key="tool.id" @click="toolClicked(tool)">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" :value="tool" v-model="selectedTools" :id="'tool-'+tool.id">
                        <label class="form-check-label" :for="'tool-'+ tool.id">
                            {{ tool.name }}
                        </label>
                    </div>
                    <!-- Attributes -->
                    <div v-for="attribute in tool.attributes" :key="attribute.id" class="d-flex flex-row ml-4 mb-1">
                        <span class="col-4">{{attribute.name}}</span>
                        <!-- Switch -->
                        <div v-if="attribute.type == 2" class="d-flex justify-content-end col-8 p-0">
                            <CSwitch shape="pill" color="primary" :checked.sync="attribute.value"/>
                        </div>
                        <input class="col-8" v-else :type="attribute.type == 0 ? 'text' : 'number'" v-model="attribute.value"/> 
                    </div>
                    <hr/>
                </div>
                <p v-if="hasError">Por favor, confirme que todos os atributos estão preenchidos.</p>
            </CCol>
        </CRow>
        <!-- Footer buttons -->
        <footer slot="footer">
            <button type="button" class="mr-1 btn btn-secondary" @click="cancelTapped"> Cancelar </button>
            <button type="button" class="ml-1 btn btn-primary" @click="okTapped"> Confirmar </button>
        </footer>
    </CModal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data()
    {
        return {
            inputEnabled: true, // This will be false while loading attributes
            selectedTools: [],
            hasError: false
        }
    },
    props:{    
        value:
        {
            type: Boolean,
            default: false
        },
        task:
        {
            type: Object,
            default: null
        },
        tools:
        {
            type: Array,
            default: () => []
        },
    },
    computed:{
        ...mapState('tasks', ['taskOutput']),
        ...mapState('tools', ['toolOutput']),
        taskDetails: function()
        {
            return this.taskOutput && this.taskOutput.obj ? this.taskOutput.obj.task : null;
        },
        toolDetails: function()
        {
            return this.toolOutput && this.toolOutput.obj ? this.toolOutput.obj.tool : null;
        }
    },
    methods:
    {
        ...mapActions('tasks', ['getTask']),
        ...mapActions('tools', ['getTool']),
        cancelTapped: function()
        {
            this.$emit('cancel-tapped');
            this.$emit('input', false);
        },
        okTapped: function()
        {
            let self = this;
            this.hasError = false;

            // Validate
            this.selectedTools.forEach(tool => {
                if(tool.attributes)
                {
                    tool.attributes.some(attribute => {
                        if(!attribute.value)
                        {
                            self.hasError = true;
                        }

                        return !self.hasError;
                    });
                }
            });

            if(!this.hasError)
            {
                this.$emit('ok-tapped', this.selectedTools);
                this.$emit('input', false);
            }
        },
        toolClicked: function(tool)
        {
            if(!this.selectedTools.includes(tool))
            {
                this.inputEnabled = false;
                this.getTool(tool.id);
            }
        }
    },
    mounted: function()
    {
        if(this.task)
        {
            this.getTask(this.task.id);
        }
    },
    watch:
    {
        value: function(val)
        {
            this.$emit('input', this.value);
        },
        task: function(val)
        {
            if(val)
            {
                this.getTask(val.id);
            }
        },
        toolOutput: function(val)
        {
            if(val)
            {
                this.inputEnabled = true;
                var tool = this.taskDetails.tools.find(tool => tool.id == this.toolDetails.id);

                tool.selected = true;
                tool.attributes = this.toolDetails.attributes;
            }
        }
    }
}
</script>

<style>

</style>